import React from 'react';
import classnames from 'classnames';
import Folder from '@mui/icons-material/Folder';
import PlayCircleFilled from '@mui/icons-material/PlayCircleFilled';

import VideoTimestamp from './videoTimestamp';

import styles from '../styles/videoBrowseCardMedia.module.scss';

const renderContent = (type, duration, isComplete, shouldHideFolderIcon, folderIconClassName) => {
  if (['video', 'live'].includes(type)) {
    return (
      <>
        <PlayCircleFilled className={styles.icon} sx={{ height: 44, width: 44 }} />
        {!isComplete && duration ? <VideoTimestamp duration={duration} /> : null}
      </>
    );
  }

  if (type === 'topic' && !shouldHideFolderIcon) {
    return <Folder className={classnames(styles.folder, folderIconClassName)} sx={{ height: 24, width: 24 }} />;
  }

  return null;
};

const VideoBrowseCardMedia = ({
  duration, type, isComplete, shouldHideFolderIcon, folderIconClassName
}) => (
  <>
    {renderContent(type, duration, isComplete, shouldHideFolderIcon, folderIconClassName)}
  </>
);

export default VideoBrowseCardMedia;
